import { pageId } from "@octopusdeploy/portal-routes";
export default () => ({
    deployments: pageId({ area: "Project", id: "Project.Deployments", name: "Deployments" }),
    deployment: pageId({ area: "Project", id: "Project.Deployment", name: "Deployment" }),
});
